import { render } from "./important-contacts.vue?vue&type=template&id=1ef54bf2"
import script from "./important-contacts.vue?vue&type=script&lang=js"
export * from "./important-contacts.vue?vue&type=script&lang=js"

import "./important-contacts.vue?vue&type=style&index=0&id=1ef54bf2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__